import SignIn from 'routes/public/SignIn'

export default SignIn
